@if (!icError) {
  <div style="height:300px" class="mb-3">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="icMaintainAspectRatio"
      [aspectRatio]="icAspectRatio" [format]="icFormat" (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()">
    </image-cropper>
  </div>
}

@if (icNotes) {
  <div class="form-note mb-3">
    {{icNotes}}
  </div>
}

@if (icError) {
  <div class="form-error my-3">
    @for (error of errors; track error) {
      <div class="form-error-message-inline">
        {{error}}
      </div>
    }
    <div class="form-error-message-inline">Please upload a new image</div>
  </div>
}

<input #fileInput [hidden]="imageChangedEvent" type="file" (change)="newImage($event)" [accept]="icAcceptTypes" />

<hr>

  <button class="btn btn-primary" (click)="finalizeCroppedImage()" [disabled]="icError || loading">
    @if (loading) {
      <span class="spinner-border spinner-border-sm"></span>
      <span  role="status">Uploading...</span>
    }
    @if (!loading) {
      Upload Image
    }
  </button>
  <button class="btn " (click)="fileInput.click()" [hidden]="!imageChangedEvent || loading">Change Image</button>